import { createSelector } from 'reselect';
import { fromJS } from 'immutable';
import {
  ROUTE_COURSE_ADMIN,
  ROUTE_COHORT_ADMIN,
  ROUTE_COURSE_ASSESSMENT,
  ROUTE_COURSE_CERTIFICATION,
  ROUTE_COURSE_PROGRESS,
  ROUTE_COURSE_PAGE,
} from '../../routeActions';
import {
  selectType,
  selectPayload,
  selectQuery,
  selectState,
} from '../../location/selectors';

/**
 * WARNING:
 * This selector is not a reliable way to get the current course path.
 * For components, see selectCurrentCoursePath, selectCurrentInstitutionPath
 * (Those selectors use this one and other information to determine the
 * current course/institution path in a reliable way)
 */
export const selectCurrentCoursePathState = createSelector(
  [selectType, selectPayload, selectQuery, selectState],
  (locationType, params, query, state) => {
    switch (locationType) {
      case ROUTE_COURSE_PAGE: {
        const institutionPrefix = state.get('institutionPrefix');
        if (institutionPrefix) {
          return fromJS({
            coursePath: `${institutionPrefix.toLowerCase()}/courses/${params
              .get('courseCode')
              .toLowerCase()}`,
            courseCode: params.get('courseCode').toLowerCase(),
          });
        } else {
          return fromJS({
            coursePath: `courses/${params.get('courseCode').toLowerCase()}`,
            courseCode: params.get('courseCode').toLowerCase(),
          });
        }
      }
      case ROUTE_COURSE_ADMIN:
      case ROUTE_COHORT_ADMIN:
      case ROUTE_COURSE_ASSESSMENT:
      case ROUTE_COURSE_PROGRESS:
      case ROUTE_COURSE_CERTIFICATION: {
        return fromJS({
          coursePath: query.get('course').toLowerCase(),
          courseCode: query.get('course').split('courses/')[1],
        });
      }
      default: {
        return fromJS({
          coursePath: null, // Set when the entire path is available
          courseCode: null, // Set when the institution prefix is not available
        }); // A routing action for another page
      }
    }
  }
);
